import { defineStore } from 'pinia'
import { type TPage } from '~/types/page-types'

type TPagePartial = {
    title?: string,
    collection?: string
}

type TStoreState = {
    page: TPage | TPagePartial | undefined
    cookieBannerLoaded: boolean
    npoTagLoaded: boolean
    tagLoaded: boolean
    showProgressBar: boolean
};

export const usePageStore = defineStore('pages', {
  state: (): TStoreState => {
    return {
      page: undefined,
      cookieBannerLoaded: false,
      npoTagLoaded: false,
      tagLoaded: false,
      showProgressBar: false
    }
  },
  actions: {
    setCurrentPage (data: TPage | TPagePartial | undefined) {
      this.$state.page = data
      console.info('ℹ Page store updated')
    },
    setShowProgressBar (newValue: boolean) {
      this.$state.showProgressBar = newValue
    },
    setCookieBannerLoaded (newValue: boolean) {
      this.$state.cookieBannerLoaded = newValue
    },
    setTagLoaded (newValue: boolean) {
      this.$state.tagLoaded = newValue
    },
    setNpoTagLoaded (newValue: boolean) {
      this.$state.npoTagLoaded = newValue
    }
  },
  getters: {
    getCurrentPage: state => state.page,
    getShowProgressBar: state => state.showProgressBar,
    getCookieBannerLoaded: state => state.cookieBannerLoaded,
    getTagLoaded: state => state.tagLoaded,
    getNpoTagLoaded: state => state.npoTagLoaded
  }
})
